import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/global.css";
import "boxicons";

const app = createApp(App);
const appDiv = document.querySelector("#app");
app.mount("#app");

app.config.globalProperties.$documentOrder = JSON.parse(
  appDiv.getAttribute("cring-document-order")
) || [167, 97, 96, 51, 40001, 79, 739];